module.exports = __webpack_public_path__ + "static/sala_de_juntas-min-e549283faa6a662e55781379d68ac4de.jpg";